import React from 'react';

import { Description, Field, Label } from '@headlessui/react';

import DAlert from '@/components/Global/DAlert';
import DTransition from '@/components/Global/DTransition';
import InfoIcon from '@/shared/icons/InfoIcon';
import DTooltip from '@/components/Global/DTooltip';
import clsx from 'clsx';
import DSpinner from '@/components/Global/DSpinner';

const DInputBlock = React.forwardRef(
  (
    {
      children,
      error,
      alert,
      name,
      label,
      description,
      className = '',
      note,
      hiddenLabel = false,
      labelClassName = '',
      required = false,
      tooltipContent,
      size = 'md',
      shouldGrow = true,
      hideError = false,
      loader = false,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={clsx('relative', className, {
          'w-full grow': shouldGrow,
          'grow-0': !shouldGrow,
        })}
      >
        <Field className="flex flex-col gap-v3-xs" ref={ref}>
          {!hiddenLabel && (
            <Label
              className={clsx(
                labelClassName,
                'text-base font-medium tracking-tight flex items-center gap-v3-xxs',
                {
                  '!text-xs': size === 'sm',
                }
              )}
            >
              <div className="flex items-center gap-v3-xs">
                <span className="w-max">
                  {label} {required && <span className="text-error">*</span>}
                </span>
                {loader && <DSpinner />}
              </div>
              {tooltipContent && (
                <DTooltip content={tooltipContent}>
                  <InfoIcon
                    className={clsx({
                      '!size-size3': size === 'sm',
                    })}
                  />
                </DTooltip>
              )}
            </Label>
          )}
          {description && (
            <Description className="text-xs text-grey-50">
              {description}
            </Description>
          )}

          {children}
          {note && (
            <span className="text-xs tracking-tight text-grey-20">{note}</span>
          )}

          {!hideError && (
            <div className="relative h-0 pb-2">
              <span
                className="transition-all duration-300 absolute text-error h-4 "
                dangerouslySetInnerHTML={{ __html: error }}
              />
            </div>
          )}
        </Field>
      </div>
    );
  }
);

DInputBlock.displayName = 'DInputBlock';

export default DInputBlock;
